<template>
  <div class="file_container">
    <van-nav-bar
      title="护理员请假申请"
      @click-left="$router.push('/')"
      left-arrow
      safe-area-inset-top
      placeholder
    />
    
    <div class="NurseDetail">
      <div class="form">
        <van-field
          readonly
          clickable
          required
          input-align="right"
          label="请假类型"
          :value="selectedStoreName  || formData.type"
          placeholder="选择请假类型"
          @click="showPicker = true"
        />
        <van-popup v-model="showPicker" round position="bottom">
          <van-picker
            show-toolbar
            :columns="storeOptions"
            @cancel="showPicker = false"
            @confirm="onConfirmStore"
          />
        </van-popup>
        <!-- 开始时间选择 -->
        <van-field
          readonly
          clickable
          required
          input-align="right"
          label="开始时间"
          :value="formatDateTime(startDate)"
          placeholder="点击选择开始时间"
          @click="showStartPicker = true"
        />
        <van-popup v-model="showStartPicker" position="bottom">
          <van-datetime-picker
            v-model="tempStartDate"
            type="datetime"
            title="选择开始时间"
            :min-date="minDate"
            :max-date="maxDate"
            @confirm="confirmStartDate"
            @cancel="showStartPicker = false"
          />
        </van-popup>

        <!-- 结束时间选择 必须先选开始时间-->
        <van-field
          readonly
          clickable
          required
          label="结束时间"
          input-align="right"
          :value="formatDateTime(endDate)"
          placeholder="点击选择结束时间"
          @click="showEndPicker = true"
          :disabled="!startDate"
        />
        <van-popup v-model="showEndPicker" position="bottom">
          <van-datetime-picker
            v-model="tempEndDate"
            type="datetime"
            title="选择结束时间"
            :min-date="startDate || minDate"
            :max-date="maxDate"
            @confirm="confirmEndDate"
            @cancel="showEndPicker = false"
          />
        </van-popup>

        <van-field
          v-model="formData.comment"
          name="请假事由"
          label="请假事由"
          required
          placeholder="请填写请假事由"
          input-align="right"
        />

        <!-- 上传按钮 -->
        <van-uploader
          v-model="imageFiles"
          multiple
          :max-count="9"
          :before-read="beforeImageRead"
          :after-read="afterImageRead"
          accept="image/*"
          capture="camera"
          @delete="handleDelete"
        >
          <van-button icon="photograph" type="primary">拍照上传</van-button>
        </van-uploader>

        <!-- 图片预览区域 -->
        <div v-if="imageFiles.length > 0" class="preview-container">
          <div v-for="(file, index) in imageFiles" :key="index" class="preview-item">
            <img :src="file.content || file.url" class="preview-image" />
            <van-icon name="clear" class="delete-icon" @click="handleDelete(file)" />
          </div>
        </div>

        <!-- 隐藏字段，用于表单提交 -->
        <input type="hidden" name="images" :value="imageString" />

      </div>

      <div class="btn">
        <van-button round block type="info" @click="submmit"
          >申请</van-button
        >
      </div>
      <div class="title"></div>
    </div>
  </div>
</template>

<script>
import { apply,imgUrl } from "@/api/index";
import { Toast } from "vant";
import { Uploader } from 'vant';
export default {
  name: "",
  components: {
    'van-uploader': Uploader
  },
  data() {
    return {
      selectedStoreName:"",
      storeOptions: [
        { value: 1, text: '事假' },
        { value: 2, text: '病假' },
        { value: 3, text: '调休假' },
        { value: 4, text: '婚假' },
        { value: 5, text: '产假' },
        { value: 6, text: '陪产假' },
        { value: 0, text: '其他' },
      ],
      showPicker:false,
      formData: {},
      // 时间范围限制（可根据需求调整）
      minDate: new Date(2000, 0, 1),
      maxDate: new Date(2100, 11, 31),
      
      // 开始时间相关
      startDate: null,
      tempStartDate: new Date(),
      showStartPicker: false,
      
      // 结束时间相关
      endDate: null,
      tempEndDate: new Date(),
      showEndPicker: false,

      imageFiles: [],
      token: "",
      url_prefix: "",
      uploadedUrls: [] // 已上传成功的URL
    };
  },
  computed: {
    // 计算属性：生成逗号分隔的图片URL字符串
    imageString() {
      return this.uploadedUrls.join(",");
    }
  },  
  created() {
    this.initToken();
  },
  watch: {
    // 清空时重置字符串
    fileList(val) {
      if (val.length === 0) this.photoAttachments = '';
    },
    // 监听imageString变化，触发v-model更新
    imageString(newVal) {
      this.$emit("input", newVal);
    },
    // 初始化时处理传入的图片字符串
    value: {
      immediate: true,
      handler(newVal) {
        if (newVal && this.imageFiles.length === 0) {
          this.initFiles(newVal);
        }
      }
    }
  },
  methods: {
    /// 初始化七牛云token
    initToken() {
      imgUrl().then((res) => {
        if (res.data.success) {
          this.token = res.data.result.token;
          this.url_prefix = res.data.result.url;
        }
      });
    },

    // 初始化已有图片
    initFiles(urls) {
      if (!urls) return;
      
      const urlArray = urls.split(",").filter(url => url.trim());
      this.uploadedUrls = [...urlArray];
      
      this.imageFiles = urlArray.map(url => ({
        url,
        content: url,
        status: 'done',
        message: '上传成功'
      }));
    },

    // 上传前校验
    beforeImageRead(file) {
      const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        Toast.fail("请上传JPG或PNG格式的图片!");
        return false;
      }
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        Toast.fail("图片大小不能超过5M!");
        return false;
      }
      return true;
    },

    // 上传到七牛云
    afterImageRead(file) {
      Toast.loading({
        message: '上传中...',
        forbidClick: true,
        duration: 0
      });

      const formData = new FormData();
      formData.append("file", file.file);
      formData.append("token", this.token);
      formData.append("key", `upload_${Date.now()}_${Math.random().toString(36).substr(2, 9)}.jpg`);

      fetch("https://up.qiniup.com", {
        method: "POST",
        body: formData
      })
      .then(response => response.json())
      .then(res => {
        if (res.key) {
          const imageUrl = `${this.url_prefix}/${res.key}`;
          file.url = imageUrl;
          file.content = imageUrl;
          file.status = 'done';
          
          // 添加到已上传URL列表
          this.uploadedUrls.push(imageUrl);
          
          Toast.success("上传成功");
        } else {
          file.status = 'failed';
          file.message = '上传失败';
          Toast.fail("上传失败");
        }
      })
      .catch(() => {
        file.status = 'failed';
        file.message = '上传失败';
        Toast.fail("上传失败");
      });
    },

    // 删除图片
    handleDelete(file) {
      if (file.url) {
        // 从uploadedUrls中移除对应的URL
        this.uploadedUrls = this.uploadedUrls.filter(url => url !== file.url);
      }
      // 从imageFiles中移除对应的文件
      this.imageFiles = this.imageFiles.filter(f => f !== file);
    },
    onConfirmStore(e) {
      // value 是选中的整个对象
      this.showPicker = false;
      this.selectedStoreName = e.text;
      this.formData.type = e.value;
    },
    
    // 格式化日期时间显示为 YYYY-MM-DD HH:mm
    formatDateTime(date) {
      if (!date) return '';
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    // 格式化日期显示为 YYYY-MM-DD
    formatDate(date) {
      if (!date) return '';
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    // 确认开始时间
    confirmStartDate(date) {
      this.startDate = new Date(date);
      this.showStartPicker = false;
      this.endDate = null; // 重置结束时间
    },

    // 确认结束时间
    confirmEndDate(date) {
      this.endDate = new Date(date);
      this.showEndPicker = false;
      
      // 验证时间范围
      if (this.endDate < this.startDate) {
        this.$toast('结束时间不能早于开始时间');
        this.endDate = null;
      }
    },
    submmit() {
      // 验证必填字段
      if (!this.formData.type) {
        Toast.fail("请选择请假类型");
        return;
      }
      if (!this.startDate || !this.endDate) {
        Toast.fail("请选择请假时间范围");
        return;
      }
      if (!this.formData.comment) {
        Toast.fail("请填写请假事由");
        return;
      }
      const formData = {
        type : this.formData.type,
        // startTime : this.formatDate(this.startDate),
        // endTime : this.formatDate(this.endDate),
        startTime: this.startDate.getTime(), // 转换为时间戳
        endTime: this.endDate.getTime(),     // 转换为时间戳
        comment : this.formData.comment,
        attachment : this.imageString,
      }
      // console.log('formData',formData);
      
      apply(formData).then((res) => { 
        Toast.clear(); // 清除加载中提示
        
        if (res.data.success) {
          // 提交成功，显示成功提示
          Toast.success({
            message: res.data.message || '提交成功',
            duration: 1000, // 显示1.5秒
            onClose: () => {
              // 提示关闭后跳转首页
              this.$router.push('/');
            }
          });
        } else {
          // 提交失败，显示错误提示（不自动关闭）
          Toast.fail(res.data.message || '提交失败');
        }
      }).catch(error => {
        Toast.clear();
        Toast.fail('请求失败，请稍后重试');
        console.error('提交失败:', error);
      });
    },
  },
};
</script>
<style lang="less" scoped>
.file_container {
  background-color: rgba(232, 232, 232, 0.815);
  min-height: 100vh;
}

/deep/ .van-nav-bar {
  background: #0dacf4;

  .van-nav-bar__title {
    color: #fff;
  }
}

/deep/ .van-nav-bar__left {
  .van-icon {
    color: #fff;
  }
}
.preview-container {
  display: flex;
  flex-wrap: wrap;
  margin-top: 15px;
}

.preview-item {
  position: relative;
  width: 100px;
  height: 100px;
  margin: 0 10px 10px 0;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}

.delete-icon {
  position: absolute;
  right: -8px;
  top: -8px;
  color: #f44;
  font-size: 18px;
  background: white;
  border-radius: 50%;
  z-index: 1;
}

.van-uploader {
  display: flex;
  justify-content: center;
  margin: 15px 0;
}

.page {
  margin-top: 20px;
}
</style>
